import _styled from "styled-components";
const _excluded = ["message", "t", "boxProps", "textProps", "hideMessage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { withTranslation } from "react-i18next";
import Box from "../Styled/Box";
import { TextSpan } from "../Styled/Text";
import AnimatedSpinnerIcon from "../Styled/AnimatedSpinnerIcon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Loader = props => {
  const {
      message,
      t,
      boxProps,
      textProps,
      hideMessage
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    fullWidth: true,
    centered: true
  }, boxProps), {}, {
    children: [/*#__PURE__*/_jsx(_StyledAnimatedSpinnerIcon, _objectSpread(_objectSpread({
      styledWidth: "15px"
    }, rest), {}, {
      $_css: "margin: 5px"
    })), /*#__PURE__*/_jsx(TextSpan, _objectSpread(_objectSpread({}, textProps), {}, {
      children: !hideMessage && (message || t("loader.loadingMessage"))
    }))]
  }));
};
export default withTranslation()(Loader);
var _StyledAnimatedSpinnerIcon = _styled(AnimatedSpinnerIcon).withConfig({
  displayName: "Loader___StyledAnimatedSpinnerIcon",
  componentId: "sc-1s9fu87-0"
})(["", ""], p => p.$_css);